import {
	Notify,
	ActionSheet,
	Tab,
	Tabs,
	List,
	Cell,
	CellGroup,
	Picker,
	DatetimePicker,
	Popup,
	Uploader,
	Badge,
	Form,
	Button,
	Radio,
	RadioGroup,
	Empty,
	Dialog,
	Field,
	Checkbox,
	Popover,
	Toast,
	PasswordInput,
	NumberKeyboard,
	CountDown,
	Overlay,
	Tabbar,
	TabbarItem,
	Col,
	Row,
	Grid,
	GridItem,
	Switch,
	Cascader,
	Image,
	Divider,
	Icon,
	Tag,
	CheckboxGroup,
	Calendar,
	Loading,
	Sticky,
	Search,
	DropdownMenu,
	DropdownItem
} from 'vant'

Toast.setDefaultOptions({ duration: 3000 })
const components = [
	Notify,
	ActionSheet,
	Tab,
	Tabs,
	List,
	Cell,
	CellGroup,
	Picker,
	DatetimePicker,
	Popup,
	Uploader,
	Badge,
	Form,
	Button,
	Radio,
	RadioGroup,
	Empty,
	Dialog,
	Field,
	Checkbox,
	Popover,
	Toast,
	PasswordInput,
	NumberKeyboard,
	CountDown,
	Overlay,
	Tabbar,
	TabbarItem,
	Col,
	Row,
	Grid,
	GridItem,
	Switch,
	Cascader,
	Image,
	Divider,
	Icon,
	Tag,
	CheckboxGroup,
	Calendar,
	Loading,
	Sticky,
	Search,
	DropdownMenu,
	DropdownItem
]

export default Vue => components.forEach(item => Vue.use(item))
